<template>
  <div
    :class="$style.root"
  >
    <i18nLink
      :class="$style.item"
      :to="{
        name: 'program-slug',
        params: {
          slug: slug
        }
      }"
    >
      <div
        v-if="status !== 'unknown'"
        :class="$style.status"
      >
        <div v-if="tag" :class="$style.tag">{{ tag }}</div>
        <LayoutHorizontalLineComponent />
      </div>

      <div :class="$style.title">
        {{ title }}
      </div>

      <div :class="$style.details">
        <div :class="$style.info">
          <span v-if="status" :class="$style.tag">{{ status }}</span>
          <CoreDateTimeRangeComponent
            :class="$style.dateTimeRange"
            v-for="range in localizedData?.date_time_ranges"
            :key="range?.id"
            :dateStart="range?.date_time_start"
            :dateEnd="range?.date_time_end"
          />
        </div>

        <CoreImageComponent
          v-if="localizedData?.cover_image?.data?.attributes"
          :image="localizedData?.cover_image?.data?.attributes"
          :class="$style.image"
        />

        <CoreTextComponent
          v-if="introduction"
          :class="$style.introduction"
          :string="introduction"
        />
      </div>
    </i18nLink>
  </div>
</template>

<script setup>
const props = defineProps({
  data: Object
})

const localizedData = computed(() => {
    return i18nGetLocalizedData(baseStrapiGetAttributes(props?.data))
})

const title = computed(() => {
  return localizedData?.value?.titles?.current_locale || localizedData?.value?.titles?.i18n_title_en
})

const slug = computed(() => {
  return localizedData?.value?.slugs?.current_locale || localizedData?.value?.slugs?.i18n_slug_en
})

const status = props?.forcePastStatus ? 'past' : getItemProgramStatus(props?.data)

const introduction = computed(() => {
  return baseTruncateString(localizedData?.value?.introductions?.current_locale || localizedData?.value?.introductions?.i18n_richtext_en, 20)
})

const tag = computed(() => {
  return localizedData?.value?.tags?.current_locale || localizedData?.value?.tags?.i18n_text_en
})
</script>

<style module lang="scss">
.root {
}

.item {
  display: flex;
  flex-direction: column;
}

.item:hover  {
  color: var(--color--accent);
}

.status {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--unit--spacer);

  width: 25vw;
  max-width: var(--container--default--without-padding);

  @media (max-width: $breakpoint-m) {
    width: 100%;
  }

  margin-left: auto;
  margin-right: auto;
  margin-bottom: calc(var(--unit--spacer) * 2);

  text-transform: uppercase;
}

.title {
  composes: font-size-large from global;
  margin-bottom: var(--unit--spacer);
  text-align: center;
}

.details {
  display: grid;
  grid-template-areas: 'image image'
                       'dateTimeRange introduction';
  grid-template-columns: min-content 1fr;
  grid-column-gap: var(--unit--horizontal);
  grid-row-gap: var(--unit--spacer);
  align-items: start;

  @media (max-width: $breakpoint-l) {
    grid-template-areas: 'image'
                         'dateTimeRange'
                         'introduction';
    grid-template-columns: 1fr;
    grid-column-gap: var(--unit--horizontal);
    grid-row-gap: var(--unit--spacer);
    align-items: start;
  }
}

.details .dateTimeRange {
  display: block;
}

.details .dateTimeRange time {
  display: inline-block;
}

.details .tag {
  text-transform: uppercase;
  word-break: break-all;
}

.details .info {
  text-align: right;
  @media (max-width: $breakpoint-l) {
    text-align: left;
  }
}

.details .image {
  grid-area: image;

  max-width: 25vw;
  width: 100%;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: $breakpoint-m) {
    max-width: 100%;
  }
}

.details .dateTimeRange {
  grid-area: dateTimeRange;
  white-space: nowrap;
}

.details .introduction {
  grid-area: introduction;
}
</style>
